<template>
  <Container>
    <div class="logo-container">
      <Logo />
    </div>
    <Header>{{ translate('resetpassword') }}</Header>
    <div class="desc">
      {{ translate('resetpassword-expired-subtitle') }}
    </div>
    <Button @click="goToForgotPasswordPage">{{ translate('resetpassword-expired-btn') }}</Button>
  </Container>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { Button, Header, Container, Logo } from '../atoms/'
import { mapGetters } from 'vuex';
import { APP_MODULE, TRANSLATE } from '@/store/modules/app/constant';
@Component({
  components: {
    Button,
    Container,
    Header,
    Logo
  },
  computed: {
    ...mapGetters(APP_MODULE, [TRANSLATE])
  }
})
export default class ResetPassword extends Vue {
  goToForgotPasswordPage() {
    this.$router.push({
      path: '/forgot-password',
      query: { email: this.$route?.query?.email, channel: this.$route?.query?.channel }
    })
  }
}
</script>

<style lang="scss">
.desc {
  margin: 16px 0 32px 0;
}
</style>
